import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import OffsetSlider from 'components/sliders/OffsetSlider';
import Section from 'components/Section';
import MovieCard from 'components/cards/entities/MovieCard';

import { MovieType } from 'propTypes/entities';

const Movies = ({ entities, title, subtitle, url }) => {
	const hasPortraitCards = _(entities).find(
		(entity) => entity.type === 'movie' || entity.type === 'performance'
	);
	const typeWidth = hasPortraitCards ? 'landingPortrait' : 'landingLandscape';
	const params = hasPortraitCards
		? { width: 214, height: 286 }
		: { width: 397, height: 284 };

	return (
		<Section
			title={title}
			align="center"
			titleSize="medium"
			subtitle={subtitle}
			url={url}
		>
			<OffsetSlider>
				{_(entities).map((entity) => (
					<MovieCard
						{...{
							entity,
							params,
							typeWidth
						}}
						key={entity._id}
					/>
				))}
			</OffsetSlider>
		</Section>
	);
};

Movies.propTypes = {
	entities: PropTypes.arrayOf(MovieType).isRequired,
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	url: PropTypes.string
};

Movies.defaultProps = {
	subtitle: null,
	url: null
};

export default Movies;
